import { $post, $get } from '../utils/request'



export const $noticeTYJ= async () => {
   
    console.log("推送体育局开始")
    let res = await $post('notice.do', { "team_id": "admin" });
    console.log(res)
    console.log("推送体育局结束")
    return res;
}


export const $fetchTeamOptions = async () => {
   
    console.log("查询团队")
    let res = await $post('fetchTeamOptions.do', { "team_id": "admin" });
    console.log(res)
    return res;
}


export const $fetchTeacherOptions = async (team_id) => {
    
    if(team_id==''){
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        console.log(userInfo)
        if (userInfo.team_id) {
            team_id = userInfo.team_id;
        }
    }

    

    console.log("查询团队下的老师")
    let res = await $post('fetchTeacherOptions.do', { "team_id": team_id });
    console.log(res)
    return res;
}

//查询列表
export const $getCurriculumList = async (params) => {
    console.log("查询课程信息开始")
    params.team_id=""
    console.log(params)
    let res = await $post('getCurriculumList.do', params);

    return res;
}





/**
 * 
 * @param {新增课程} params 
 * @returns 
 */
export const $submitCurriculum = async (params) => {
    console.log("提交课程信息开始")

    console.log(params)
    let res = await $post('submitCurriculum.do', params);
    console.log(res)
    console.log("提交课程信息结束")
    return res;
}




export const $deleteKeCheng = async (params) => {
    console.log("提交课程信息开始")

    console.log(params)
    let res = await $post('deleteKeCheng.do', params);
    console.log(res)
    console.log("提交课程信息结束")
    return res;
}